
import { MARKETPLACES_REQUEST, MARKETPLACES_SUCCESS, MARKETPLACES_FAILURE } from './actionTypes';
import { MARKETPLACES_ACCOUNT_REQUEST, MARKETPLACES_ACCOUNT_SUCCESS, MARKETPLACES_ACCOUNT_FAILURE } from './actionTypes';
import { ADD_MARKETPLACES_REQUEST, ADD_MARKETPLACES_SUCCESS, ADD_MARKETPLACES_FAILURE } from './actionTypes';
import { UPDATE_MARKETPLACES_REQUEST, UPDATE_MARKETPLACES_SUCCESS, UPDATE_MARKETPLACES_FAILURE } from './actionTypes';
import authService from '../../services/marketplacesService';


export const marketPlacesRequest = () => ({
  type: MARKETPLACES_REQUEST,
});

export const marketPlacesSuccess = (user) => ({
  type: MARKETPLACES_SUCCESS,
  payload: user,
});

export const marketPlacesFailure = (error) => ({
  type: MARKETPLACES_FAILURE,
  payload: error,
});
export const getMarketPlaces = (token) => {

  return async (dispatch) => {
    dispatch(marketPlacesRequest());
    try {

      const response = await authService.getMarketPlacesApi(token);
      dispatch(marketPlacesSuccess(response.data.data));
   
      if (response?.status=== 401) {
       localStorage.removeItem('userData');
       location.href = '/auth';
      }
      return response.data.data;
      
    } catch (error) {
  
      if (error?.status=== 401) {
       localStorage.removeItem('userData');
       location.href = '/auth';
      }
      dispatch(marketPlacesFailure(error.response?.data || 'mağzalar bulunamadı!'));
      throw error;
    }
  };
};




export const addMarketPlacesRequest = () => ({
  type: ADD_MARKETPLACES_REQUEST,
});

export const addMarketPlacesSuccess = (user) => ({
  type: ADD_MARKETPLACES_SUCCESS,
  payload: user,
});

export const addMarketPlacesFailure = (error) => ({
  type: ADD_MARKETPLACES_FAILURE,
  payload: error,
});
export const addMarketPlacesAccount = (data,token) => {
 
  return async (dispatch) => {
    dispatch(addMarketPlacesRequest());
    try {
      const response = await authService.addMarketPlaceApi(data,token);
      dispatch(addMarketPlacesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(addMarketPlacesFailure(error.response?.data || 'MAĞZA BİLGİLERİ EKLENEMEDİ!'));
      throw error;
    }
  };
  
};



export const marketPlacesAccountRequest = () => ({
  type: MARKETPLACES_ACCOUNT_REQUEST,
});

export const marketPlacesAccountSuccess = (user) => ({
  type: MARKETPLACES_ACCOUNT_SUCCESS,
  payload: user,
});

export const marketPlacesAccountFailure = (error) => ({
  type: MARKETPLACES_ACCOUNT_FAILURE,
  payload: error,
});
export const getMarketPlacesAccounts = (id,token) => {

  return async (dispatch) => {
    dispatch(marketPlacesRequest());
    try {
      const response = await authService.getMarketPlacesAccountsApi(id,token);
      dispatch(marketPlacesSuccess(response.data?.data));
      return response.data?.data;
    } catch (error) {
      dispatch(marketPlacesFailure(error.response?.data || 'Mağza bilgileri bulunamadı!'));
      throw error;
    }
  };
  
};


export const updateMarketPlacesRequest = () => ({
  type: UPDATE_MARKETPLACES_REQUEST,
});

export const updateMarketPlacesSuccess = (user) => ({
  type: UPDATE_MARKETPLACES_SUCCESS,
  payload: user,
});

export const updateMarketPlacesFailure = (error) => ({
  type: UPDATE_MARKETPLACES_FAILURE,
  payload: error,
});
export const updateMarketPlacesAccount = (data,token) => {

  return async (dispatch) => {
    dispatch(updateMarketPlacesRequest());
    try {
      const response = await authService.updateMarketPlaceApi(data,token);
     
      dispatch(updateMarketPlacesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(updateMarketPlacesFailure(error.response?.data || 'MAĞZA BİLGİLERİ güncellenemedi!'));
      throw error;
    }
  };
  
};